import axios from 'axios';
import types from './mutations-types';

const actions = {
  async getUsersMaster({ commit }, obj) {
    const { data } = await axios.get(`${process.env.API_ROOT}/master/users`, {
      headers: {
        'x-access-token': obj.token,
      },
      params: {
        page: obj.page,
        limit: obj.limit,
        filter: obj.filter,
      },
    });

    commit(types.SET_COMPANIES_USERS, data);
  },

  async getCompanies({ commit }, obj) {
    const { data } = await axios.get(`${process.env.API_ROOT}/companies`, {
      headers: {
        'x-access-token': obj.token,
      },
      params: {
        page: obj.page,
        limit: obj.limit,
        filter: obj.filter,
      },
    });

    data.total = Math.ceil(data.total / 5);
    commit(types.SET_SYSTEM_COMPANIES, data);
  },

  async getAllCompanies({ commit }, obj) {
    const companies = [{ value: '0', text: 'Escolha uma opção' }];
    const { data } = await axios.get(`${process.env.API_ROOT}/companies`, {
      headers: {
        'x-access-token': obj.token,
      },
      params: {
        justIds: obj.justIds,
      },
    });

    data.companies.forEach((el) => {
      companies.push({
        value: el._id,
        text: el.name,
      });
    });

    commit(types.SET_ALL_COMPANIES, companies);
  },

  async setScaleColors({ commit }, value) {
    commit(types.SET_TEMPLATE, {
      scale: value,
    });
  },
  async setBorderColors({ commit }, value) {
    commit(types.SET_TEMPLATE, {
      border: value,
    });
  },
  async setGradeColors({ commit }, value) {
    commit(types.SET_TEMPLATE, {
      grade: value,
    });
  },
  async setSegments({ commit }, value) {
    commit(types.SET_SEGMENTS, {
      segments: value,
    });
  },

  async registerNewCompany({ commit }, obj) {
    const formData = new FormData();
    formData.set('corporateName', obj.company.corporateName);
    formData.set('name', obj.company.name);
    formData.set('cnpj', obj.company.cnpj);
    formData.set('segment', obj.company.segment);
    formData.set('country', obj.company.country);
    formData.set('type', obj.company.plan.type);
    formData.set('qtyEmail', obj.company.plan.qtyEmail);
    formData.set('qtySms', obj.company.plan.qtySms);
    formData.append('file', obj.company.file);

    await axios.post(`${process.env.API_ROOT}/company`, formData, {
      headers: {
        'x-access-token': obj.token,
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async deleteCompany({ commit }, obj) {
    await axios.delete(`${process.env.API_ROOT}/company/${obj.companyId}`, {
      headers: {
        'x-access-token': obj.token,
      },
    });
  },

  async updateCompany({ commit }, obj) {
    const formData = new FormData();
    formData.set('corporateName', obj.data.corporateName);
    formData.set('name', obj.data.name);
    formData.set('cnpj', obj.data.cnpj);
    formData.set('segment', obj.data.segment);
    formData.set('type', obj.data.plan.type);
    formData.set('qtyEmail', obj.data.plan.qtyEmail);
    formData.set('qtySms', obj.data.plan.qtySms);
    formData.set('enableSentimentAnalyze', obj.data.enableSentimentAnalyze);
    formData.set('enableAttachTreatments', obj.data.enableAttachTreatments);
    formData.set('enableAudioResponse', obj.data.enableAudioResponse);
    formData.set('channelTotem', obj.data.channelTotem);
    formData.set('channelCallCenter', obj.data.channelCallCenter);
    formData.set('arred', obj.data.arred);
    formData.set('country', obj.data.country);
    formData.set('referenceDate', obj.data.referenceDate);
    formData.set('expirateTimePassword', obj.data.expirateTimePassword);
    formData.set('enableTwoFactor', obj.data.enableTwoFactor);
    formData.append('file', obj.data.file);

    await axios.put(
      `${process.env.API_ROOT}/company/${obj.companyId}`,
      formData,
      {
        headers: {
          'x-access-token': obj.token,
        },
      },
    );
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/master/actions.js